<template>
  <div v-if="visibleOpenTableName" class="open-table-banner">
    <div class="table-name">
      <strong>Open Table:</strong> {{ visibleOpenTableName }}
    </div>
  </div>
</template>

<script>
export default {
  name: "OpenTableName",
  computed: {
    openTableName() {
      return this.$store.getters.getOpenTableName;
    },
    visibleOpenTableName() {
      if (!this.openTableName) {
        return null;
      }

      return /^Online Order\s*#/i.test(this.openTableName) ? null : this.openTableName;
    },
  },
  methods: {
    goToTables() {
      this.$router.push({ name: 'tables' });
    },
  },
};
</script>

<style scoped>
.open-table-banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: var(--card-bg);
  border-bottom: var(--card-border);
  transition: background-color 0.8s ease, border-color 0.8s ease;
}

.table-name {
  font-size: 1.1em;
  color: var(--text-primary);
  transition: color 0.8s ease;
}
</style>
